(function(){
  const apiBase = '/api/auth';
  // lightweight debug logger for device-link
  window.__DL_DEBUG = true;
  function dl(tag, obj){ try { if(!window.__DL_DEBUG) return; const ts=new Date().toISOString(); console.info(`[DL][${tag}] ${ts}`, obj||''); } catch(_){} }
  dl('script_loaded', { href: location.href });

  // Context-aware element selection (supports default IDs and quick-device IDs with 'qd-' prefix)
  let els = {};
  function selectEls(prefix){
    prefix = prefix || '';
    const gid = (id) => document.getElementById(prefix + id);
    els = {
      linkCode: gid('link-code'),
      ttl: gid('expire-time-value'),
      deviceStatus: gid('device-status'), // may should be removed 
      btnRequest: gid('btn-request-code'),
      claimForm: gid('claim-form'),
      claimCode: gid('claim-code'),
      claimStatus: gid('claim-status'),
      devicesList: gid('devices-list-table'),
      
      globalSettingsModal: gid('settings-pop-up'),
      accountManagementBtn: gid('btn-account-management'),
      accountManagementModal: gid('account-management-pop-up'),
      linkedDevicesBtn: gid('open-linked-devices-btn'),
      linkedDevicesModal: gid('linked-devices-pop-up'),
      removeDeviceModal: gid('remove-device-pop-up'),
      linkButton: gid('btn-link-device'),
    };
  }
  // initialize default selection for safety
  selectEls('');

  function randId(){ return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  const wsId = sessionStorage.getItem('ss_ws_id') || randId();
  sessionStorage.setItem('ss_ws_id', wsId);
  
  let ws = null;
  let wsReady = false;
  let ttlTimer = null;
  let ttlExpiresAt = null;
  let currentLinkId = null;
  let statusPollTimer = null;
  let statusAbortController = null;
  let authUnsubscribe = null;
  let wsRedeemed = false;
  let fallbackAttempted = false;
  let expectedUserId = null;
  let fullDevicesList = [];
  let currentPage = 0;
  const DEVICES_PER_PAGE = 5;

  function setDeviceStatus(text, badgeClass){
    if (!els.deviceStatus) return;
    els.deviceStatus.textContent = text;
    els.deviceStatus.className = 'badge ' + (badgeClass || 'text-bg-secondary');
  }

  function stopTtl(){ if (ttlTimer){ clearInterval(ttlTimer); ttlTimer = null; } }
  function stopStatusPoll(){
    if (statusPollTimer){ clearInterval(statusPollTimer); statusPollTimer = null; }
    try { if (statusAbortController) { statusAbortController.abort(); } } catch(_) {}
    statusAbortController = null;
  }
  function startTtl(seconds){
    const authPop = document.querySelector('#authorization-pop-up');
    
    stopTtl();
    ttlExpiresAt = Date.now() + seconds*1000;
    function tick(){
      const remain = Math.max(0, Math.floor((ttlExpiresAt - Date.now())/1000));
      if (els.ttl) {
        const ttlValueToShow = `${Math.floor(remain/60)}:${String(remain%60).padStart(2,'0')}`
        els.ttl.setAttribute('value', ttlValueToShow);
      }
      if (remain <= 0) { stopTtl(); setDeviceStatus('expired', 'text-bg-danger'); if (els.btnRegenerate) els.btnRegenerate.disabled = false; stopStatusPoll(); }

      if (authPop) {
        const isVisibleAttribute = authPop.getAttribute('visible') === 'true';
        const isVisibleObject3D = authPop.object3D && authPop.object3D.visible;
        const isVisible = isVisibleAttribute || isVisibleObject3D;
        if (!isVisible) cleanup()
      }
    }
    tick(); ttlTimer = setInterval(tick, 1000);
  }

  function deviceFingerprint(){
    const ua = navigator.userAgent || '';
    // Very basic parse; can be improved
    let os_name = null, browser_name = null;
    if (/Android/i.test(ua)) os_name = 'Android';
    else if (/iPhone|iPad|iPod/i.test(ua)) os_name = 'iOS';
    else if (/Mac OS X/i.test(ua)) os_name = 'macOS';
    else if (/Windows NT/i.test(ua)) os_name = 'Windows';
   browser_name = detectBrowser();

    // Persistent device_key to de-duplicate devices across links
    let device_key = null;
    try {
      // Prefer storage-management helpers if present
      if (typeof getCacheItem === 'function' && typeof setCacheItem === 'function') {
        device_key = getCacheItem('ss_device_key');
        if (!device_key) {
          device_key = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Math.random().toString(36).slice(2) + Date.now().toString(36));
          setCacheItem('ss_device_key', device_key, 365*24*60); // 1 year
          if (typeof protectKey === 'function') { try { protectKey('ss_device_key'); } catch(_){} }
        }
      } else {
        device_key = localStorage.getItem('ss_device_key');
        if (!device_key) {
          device_key = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Math.random().toString(36).slice(2) + Date.now().toString(36));
          localStorage.setItem('ss_device_key', device_key);
        }
      }
    } catch(_) { /* ignore */ }

    return { os_name, browser_name, browser_version: null, make: null, model: null, app_version: null, ua, device_key };
  }

  function connectWS(){
    try {
      const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
      const urlParams = new URLSearchParams(window.location.search);
      const urlPasscode = urlParams.get('passcode');
      const passcode = urlPasscode || (function(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
      })('passcode') || '';

      let host = location.host;
      if (!host.startsWith('ws.') && !host.startsWith('localhost') && !host.match(/^\d/)) {
        host = 'ws.' + host;
      }

      let url = `${protocol}://${host}?wsId=${encodeURIComponent(wsId)}`;
      if (passcode) {
        url += `&passcode=${encodeURIComponent(passcode)}`;
      }
      dl('ws.connect', { url });
      ws = new WebSocket(url);
      ws.onopen = () => { wsReady = true; dl('ws.open', { wsId }); };
      ws.onclose = (e) => { wsReady = false; dl('ws.close', { code: e?.code, reason: e?.reason }); };
      ws.onerror = (e) => { wsReady = false; dl('ws.error', { message: e?.message }); };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          dl('ws.message', { type: msg?.type, link_id: msg?.link_id });
          if (msg && msg.type === 'device_link/linked' && msg.link_id && msg.redeem_token) {
            wsRedeemed = true;
            stopStatusPoll();
            setDeviceStatus('linked (redeeming...)', 'text-bg-info');
            redeem(msg.link_id, msg.redeem_token);
            hideAuthPopUp();
          }
        } catch(err){ dl('ws.message.parse.error', { message: err?.message }); }
      };
    } catch (err) { dl('ws.connect.error', { message: err?.message }); }
  }

  async function apiRequest(method, path, body, opts){
    dl('api.request', { method, path, hasBearer: !!(opts && opts.bearer) });
    const API = getAuthAPI();
    if (API && typeof API.makeRequest === 'function') {
      const options = {
        method,
        body: body ? JSON.stringify(body) : undefined,
        ...opts
      };
      // If bearer provided, pass it in headers. makeRequest will use it or fallback to currentSession.
      if (opts && opts.bearer) {
        options.headers = { ...options.headers, 'Authorization': `Bearer ${opts.bearer}` };
      }
      try {
        if (window.PreloaderManager) window.PreloaderManager.show();
        return await API.makeRequest(path, options);
      } finally {
        if (window.PreloaderManager) window.PreloaderManager.hide();
      }
    }

    // Fallback to fetch if AuthAPI missing (unlikely)
    const headers = { 'Content-Type': 'application/json' };
    if (opts && opts.bearer) headers['Authorization'] = `Bearer ${opts.bearer}`;
    // Attach device key for auto-linking on authenticated calls
    try {
      let dk = null;
      try { dk = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_key') : null; } catch(_) {}
      if (!dk) { try { dk = localStorage.getItem('ss_device_key'); } catch(_) {} }
      if (dk) headers['x-device-key'] = dk;
    } catch(_) {}

    if (window.PreloaderManager) window.PreloaderManager.show();
    const res = await fetch(apiBase + path, { method, headers, body: body ? JSON.stringify(body) : undefined, credentials: 'include' });
    if (window.PreloaderManager) window.PreloaderManager.hide();
    let setCookieHdr = null; try { setCookieHdr = res.headers.get && res.headers.get('set-cookie'); } catch(_) {}
    dl('api.response', { path, status: res.status, setCookie: !!setCookieHdr });
    
    const json = await res.json().catch(()=>({}));
    if (!res.ok) throw Object.assign(new Error(json.message || json.error || 'request_failed'), { status: res.status, data: json });
    return json;
  }

  async function getBearer(forceFresh){
    try {
      // Fast path: use current session if present AND likely valid
      if (!forceFresh && window.currentSession && window.currentSession.access_token) {
        return window.currentSession.access_token;
      }
      if (!forceFresh && window.currentSession && window.currentSession.app_session) {
        return '__APP_SESSION__';
      }
      // Fallback: ask backend via AuthAPI for current session (it handles refreshing internally)
      const API = getAuthAPI();
      if (API && typeof API.getSession === 'function') {
        const res = await API.getSession();
        if (res && res.success && res.session && res.session.access_token) {
          return res.session.access_token;
        }
        if (res && res.success && res.session && res.session.app_session) {
          return '__APP_SESSION__';
        }
      }
    } catch (_){ }
    return null;
  }

  function getAuthAPI() {
    return window.AuthAPI || (window.auth && window.auth.AuthAPI);
  }

  function isValidUuid(v){
    return typeof v === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v);
  }

  function setClaimEnabled(enabled, msg){
    if (els.claimStatus) els.claimStatus.textContent = msg || '';
    if (els.claimForm) {
      const btn = els.claimForm.querySelector('button[type="submit"]');
      if (btn) btn.disabled = !enabled;
    }
  }

  function setupAuthWatch(){
    try {
      // During device linking, suppress session polling to avoid noisy /session 401s
      if (window.__DL_SUSPEND_SESSION_POLL === true) { dl('authWatch.suppressed'); return; }
      // Initial gate and lightweight poller (no Supabase SDK required on client)
      (async () => {
        const token = await getBearer();
        if (!token) setClaimEnabled(false, 'Sign in to claim'); else setClaimEnabled(true, '');
      })();
      // Re-check auth state periodically while the modal is open
      authUnsubscribe = setInterval(async () => {
        if (window.__DL_SUSPEND_SESSION_POLL === true) { return; }
        const token = await getBearer();
        if (!token) setClaimEnabled(false, 'Sign in to claim'); else setClaimEnabled(true, '');
      }, 2000);
      dl('authWatch.started');
    } catch (e) { dl('authWatch.error', { message: e?.message }); }
  }

  function teardownAuthWatch(){
    try { if (typeof authUnsubscribe === 'function') authUnsubscribe(); } catch(_){ }
    authUnsubscribe = null;
  }

  async function requestCodeWithHeader(){
    setDeviceStatus('requesting...', 'text-bg-secondary');
    const fp = deviceFingerprint();
    const headers = { 'Content-Type': 'application/json', 'x-ws-id': wsId };
    const res = await fetch(apiBase + '/device-link/request', { method: 'POST', headers, body: JSON.stringify({ device_fingerprint: fp }) });
    const json = await res.json().catch(()=>({}));
    if (!res.ok) { 
      const msg = json.message || json.error || 'request_failed';
      throw new Error(msg); 
    }
    currentLinkId = json.link_id; 
    if (els.linkCode) {
      const linkCodeValue = json.code || '';
      els.linkCode.setAttribute('value', addSpaceAfter3(linkCodeValue));

      function addSpaceAfter3(str) {
        if (str.length <= 3) return str;
        return str.slice(0, 3) + ' ' + str.slice(3);
      }
    }
    if (els.btnRegenerate) els.btnRegenerate.disabled = false;
    setDeviceStatus('waiting for link', 'text-bg-warning');
    startTtl(json.ttl_sec || 300);
    stopStatusPoll();
    pollUntilLinked();
    return json;
  }

  async function pollUntilLinked(){
    // shared, guarded poller
    if (!currentLinkId || !isValidUuid(currentLinkId)) return;
    stopStatusPoll();
    statusAbortController = new AbortController();
    let attempts = 0;
    const maxAttempts = 300; // ~5 min
    statusPollTimer = setInterval(async () => {
      attempts++;
      try {
        const res = await fetch(`${apiBase}/device-link/status?link_id=${encodeURIComponent(currentLinkId)}`, { signal: statusAbortController.signal });
        const json = await res.json().catch(()=>({}));
        if (res.ok) {
          if (json.status === 'linked') {
            // If WS event missed but server hints redeem is ready, attempt fallback after a brief grace period
            if (json.redeem_hint && !wsRedeemed && !fallbackAttempted) {
              fallbackAttempted = true;
              setTimeout(() => {
                if (!wsRedeemed) redeemFallback().catch(()=>setDeviceStatus('redeem failed','text-bg-danger'));
                hideAuthPopUp();
              }, 2000);
            }
          } else if (json.status === 'expired') {
            stopStatusPoll();
            setDeviceStatus('expired', 'text-bg-danger');
          }
        } else {
          // 400 may occur if link_id becomes invalid; ignore silently during teardown
        }
      } catch (e) {
        // AbortError or network transient — ignore
      }
      if (attempts >= maxAttempts) stopStatusPoll();
    }, 1000);
  }

  async function completeAdoption(){
    setDeviceStatus('authenticated', 'text-bg-success');

    // Suppress anonymous auto-creation during session stabilization
    try {
      window.preventAnonymousCreation = true;
      if (typeof setCacheItem === 'function') {
        setCacheItem('ss_suppress_anon_until', Date.now() + 15000, 1); // 15s
      } else {
        localStorage.setItem('ss_suppress_anon_until', String(Date.now() + 15000));
      }
    } catch(_) {}

    // Refresh authoritative session from backend and update UI
    try {
      if (window.AuthAPI && typeof window.AuthAPI.getSession === 'function') {
        const data = await window.AuthAPI.getSession();
        if (data && data.success && data.session) {
          try { if (typeof updateCurrentSession === 'function') updateCurrentSession(data.session); } catch(_) {}
          try { window.currentProfile = data.profile || window.currentProfile; } catch(_) {}
          try {
            if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
              const dn = (window.currentProfile && window.currentProfile.display_name) || (data.session.user && data.session.user.user_metadata && data.session.user.user_metadata.display_name) || '';
              window.AuthUI.updateUI(data.session, dn);
            }
          } catch(_) {}
          try { document.dispatchEvent(new CustomEvent('auth:session-changed', { detail: { session: data.session } })); } catch(_) {}
          // Clear suppression flags now that we have a valid session
          try {
            window.preventAnonymousCreation = false;
            if (typeof setCacheItem === 'function') setCacheItem('ss_suppress_anon_until', Date.now() - 1, 1);
            else localStorage.removeItem('ss_suppress_anon_until');
          } catch(_) {}
          return; // No reload needed if session fetched successfully
        }
      }
    } catch(_) {}

    // Fallbacks: try minimal refresh; if still no session, retry authoritative session fetch for a short window
    try { document.dispatchEvent(new CustomEvent('auth:session-changed', { detail: { session: window.currentSession } })); } catch(_) {}
    try {
      if (window.AuthUI && typeof window.AuthUI.updateUI === 'function' && window.currentSession) {
        window.AuthUI.updateUI(window.currentSession, (window.currentSession.user && (window.currentSession.user.user_metadata && window.currentSession.user.user_metadata.display_name)) || '');
      }
    } catch(_) {}

    // Retry fetching session (do NOT create a guest here; linking must result in real account adoption)
    try {
      if (window.AuthAPI && typeof window.AuthAPI.getSession === 'function') {
        for (let i=0; i<10; i++) { // ~10s of retries
          await new Promise(r=>setTimeout(r, 1000));
          const data = await window.AuthAPI.getSession();
          if (data && data.success && data.session) {
            try { if (typeof updateCurrentSession === 'function') updateCurrentSession(data.session); } catch(_) {}
            try { window.currentProfile = data.profile || window.currentProfile; } catch(_) {}
            try {
              if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
                const dn = (window.currentProfile && window.currentProfile.display_name) || (data.session.user && data.session.user.user_metadata && data.session.user.user_metadata.display_name) || '';
                window.AuthUI.updateUI(data.session, dn);
              }
            } catch(_) {}
            try { document.dispatchEvent(new CustomEvent('auth:session-changed', { detail: { session: data.session } })); } catch(_) {}
            // Clear suppression flags
            try {
              window.preventAnonymousCreation = false;
              if (typeof setCacheItem === 'function') setCacheItem('ss_suppress_anon_until', Date.now() - 1, 1);
              else localStorage.removeItem('ss_suppress_anon_until');
            } catch(_) {}
            return;
          }
        }
      }
    } catch(_) {}
    // At this point, still no session; keep suppression active and show authenticated badge status
  }

  async function verifyAndFinalize(userIdFromServer){
    try {
      expectedUserId = userIdFromServer || expectedUserId;
      if (window.AuthAPI && typeof window.AuthAPI.getSession === 'function'){
        const data = await window.AuthAPI.getSession();
        if (data && data.success && data.session && data.session.user && data.session.user.id) {
          const got = data.session.user.id;
          if (expectedUserId && got && String(got) !== String(expectedUserId)) {
            console.warn('[device-link] session user mismatch', { expected: String(expectedUserId).slice(-6), got: String(got).slice(-6) });
          }
        }
      }
    } catch(_) {}
    await completeAdoption();
  }

  function getAuthAPI(){
    try { if (window.AuthAPI) return window.AuthAPI; } catch(_) {}
    try { if (typeof AuthAPI !== 'undefined') return AuthAPI; } catch(_) {}
    return null;
  }

  async function redeemFallback(){
    try {
      const fp = deviceFingerprint();
      const body = { link_id: currentLinkId, wsId, device_key: fp.device_key };
      dl('redeemFallback.start', { link_id: currentLinkId, wsId });
      const res = await apiRequest('POST', '/device-link/redeem-fallback', body);
      const API = getAuthAPI();
      if (res && res.session && API && typeof API.adoptSession === 'function'){
        try { await API.adoptSession(res.session); dl('redeemFallback.adopted', { uid: (res.session && res.session.user && String(res.session.user.id).slice(-6))||null }); } catch(err) { dl('redeemFallback.adopt.error', { message: err?.message }); }
      } else {
        dl('redeemFallback.noAuthAPI', { hasSession: !!(res && res.session) });
      }
      await verifyAndFinalize(res && res.user_id);
      dl('redeemFallback.done');
    } catch (e) {
      dl('redeemFallback.error', { message: e?.message });
      // leave status for next poll or manual regenerate
    }
  }

  async function redeem(linkId, token){
    try {
      dl('redeem.start', { link_id: linkId });
      const res = await apiRequest('POST', '/device-link/redeem', { link_id: linkId, redeem_token: token });
      // If server provided a session, adopt it so this device logs into the linked account
      const API = getAuthAPI();
      if (res && res.session && API && typeof API.adoptSession === 'function'){
        try { await API.adoptSession(res.session); dl('redeem.adopted', { uid: (res.session && res.session.user && String(res.session.user.id).slice(-6))||null }); } catch(err) { dl('redeem.adopt.error', { message: err?.message }); }
      } else {
        dl('redeem.noAuthAPI', { hasSession: !!(res && res.session) });
      }
      await verifyAndFinalize(res && res.user_id);
      dl('redeem.done');
    } catch (e) {
      dl('redeem.error', { message: e?.message });
      setDeviceStatus('redeem failed', 'text-bg-danger');
    }
  }

  async function claimCode(ev){
    ev && ev.preventDefault && ev.preventDefault();
    const code = (els.claimCode && els.claimCode.value || '').replace(/\D+/g,'');
    if (!code || code.length < 4) { if (els.claimStatus) {
      const text = 'Please enter a valid code';
      els.claimStatus.textContent = text;
      showMessageWithVerificationAuthUI(text)
    } return; }
    const token = await getBearer();
    if (!token) { if (els.claimStatus) els.claimStatus.textContent = 'Not signed in'; return; }
    try {
      if (els.claimStatus) els.claimStatus.textContent = 'Linking...';
      const res = await apiRequest('POST', '/device-link/claim', { code }, { bearer: token });
      let textToUserShow = '';
      if (res && res.already_linked) {
        textToUserShow =  'This device is already linked to your account. It will sign in automatically.';
      } else {
        textToUserShow =  'Linked! Your device should sign in automatically.';
      }
      if (els.claimStatus) {
        els.claimStatus.textContent = textToUserShow;
      }
      if (textToUserShow) showMessageWithVerificationAuthUI(textToUserShow)
    } catch (e) {
      const errorDetail = e.data && e.data.message ? e.data.message : (e.data && e.data.error ? e.data.error : e.message);
      const errMsg = 'Failed to link: ' + errorDetail;
      if (els.claimStatus) els.claimStatus.textContent = errMsg
      let textToUserShow = 'Failed to link device: ' + errorDetail;
      if (e && e.data && e.data.error === 'device_limit_reached') {
        textToUserShow = 'Device limit reached. Please unlink a device from your account settings and try again.';
      }
      showMessageWithVerificationAuthUI(textToUserShow)
    }

    els.claimCode.setAttribute('value', '')
    els.claimCode.value = ''
    els.claimCode.classList.add(`update-${Date.now()}`)

    if(window.gtag) gtag('event', `VR_AccountManagement_DeviceLink`);
  }

  async function refreshDevices(resetPage = false) {
    if (resetPage === true) currentPage = 0;

    const token = await getBearer();
    if (!token) { if (els.devicesMsg) els.devicesMsg.textContent = 'Sign in to view devices'; return; }

    if (els.devicesMsg) els.devicesMsg.textContent = 'Loading...';
    window.PreloaderManager.show();
    try {
      const res = await apiRequest('GET', '/devices', null, { bearer: token });
      window.PreloaderManager.hide();
      fullDevicesList = res.devices || [];

      const totalPages = Math.ceil(fullDevicesList.length / DEVICES_PER_PAGE);
      if (currentPage >= totalPages && totalPages > 0) currentPage = totalPages - 1;

      renderDevices();
    } catch (e) {
      window.PreloaderManager.hide();
      if (els.devicesMsg) els.devicesMsg.textContent = 'Error loading devices';
    }
  }

  function renderDevices() {
    if (!els.devicesList) return;
    els.devicesList.innerHTML = '';

    const start = currentPage * DEVICES_PER_PAGE;
    const end = start + DEVICES_PER_PAGE;
    const list = fullDevicesList.slice(start, end);
    const totalPages = Math.ceil(fullDevicesList.length / DEVICES_PER_PAGE);

    let currentDeviceKey = null;
    try {
      currentDeviceKey = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_key') : localStorage.getItem('ss_device_key');
    } catch (_) {}

    let dIndex = start;
    let dPositionY = 0;

    const currentTheme = getCurrentTheme();
    let isDarkTheme = currentTheme === 'Dark';

    for (const d of list) {
        const os = `${d.os_name||''} ${d.os_version||''}`.trim();
        const br = `${d.browser_name||''} ${d.browser_version||''}`.trim();
        const linkedKind = d.kind || '';
        const linkedDate = d.linked_at ||  '';
        const nickname = d.nickname || '';
        const lastUsed = d.last_seen_at || '-';
        const deviceIdShort = d.id.slice(-6).toUpperCase();

        const fp = d.fingerprint || {};
        const isCurrent = currentDeviceKey && fp.device_key === currentDeviceKey;

        let deviceName = '-'
        if (os && br) {
          deviceName = `${os} – ${br}`;
        } else if (os) {
          deviceName = os;
        } else if (br) {
          deviceName = br;
        }

        const item = document.createElement('a-entity');
        item.classList.add('device-item');
        item.dataset.deviceId = d.id;
        item.dataset.deviceName = deviceName;
        item.setAttribute('position', `0 ${dPositionY} 0`);

        const isMainDeviceHTML = linkedKind === 'main' ? `
                         <a-entity position="-0.2 0 0">
                          <a-rounded-box width="0.7" height="0.2" depth="0.01" color="#3636e3"
                                         radius="0.09" position="0 0 0.01" scale="1 1 1" opacity="1" material="shader: flat; color: #3636e3"
                          ></a-rounded-box>
                          <a-text value="Main Device" color="#fff"
                                  align="center" anchor="center" baseline="center"
                                  position="0 0 0.02" scale="0.4 0.4 0.4"></a-text>
                      </a-entity>
        ` : '';

        const isCurrentDeviceHTML = isCurrent ? `
                         <a-entity position="${linkedKind === 'main' ? '0.6' : '-0.2'} 0 0">
                          <a-rounded-box width="0.7" height="0.2" depth="0.01" color="#198754"
                                         radius="0.09" position="0 0 0.01" scale="1 1 1" opacity="1" material="shader: flat; color: #198754"
                          ></a-rounded-box>
                          <a-text value="This Device" color="#fff"
                                  align="center" anchor="center" baseline="center"
                                  position="0 0 0.02" scale="0.4 0.4 0.4"></a-text>
                      </a-entity>
        ` : '';

        item.innerHTML = `
                  <!-- Line 1 -->
                      <a-text value="${deviceName}" color=${isDarkTheme ? "#fff" : "#111"} 
                              align="left" anchor="left" baseline="center"
                              position="-2 0 0.01" scale="0.6 0.6 0.6"></a-text>
                       ${isMainDeviceHTML}
                       ${isCurrentDeviceHTML}
                      <a-text value="Connected:" color="#aaa"
                              align="left" anchor="left" baseline="center"
                              position="0.45 0 0.01" scale="0.5 0.5 0.5"></a-text>
                      <a-text value="${formatDate(linkedDate)}" color=${isDarkTheme ? "#fff" : "#111"} 
                              align="right" anchor="right" baseline="center"
                              position="2 0 0.01" scale="0.5 0.5 0.5"></a-text>
                      <!-- Line 2 -->
                      <a-entity position="-2 -0.2 0.01" class="input-wrapper" account-input>
                          <a-text value="Device name:" color="#aaa"
                                  align="left" anchor="left" baseline="top"
                                  position="0 0 0" scale="0.6 0.6 0.6"></a-text>
                          <a-rounded-box width="2.4" height="0.4" depth="0.01" color="#202028"
                                         radius="0.09" position="1.2 -0.4 0" scale="1 1 1" opacity="1" material="shader: flat; color: ${isDarkTheme ? '#202028' : '#F4F4F4'}"
                                         data-raycastable="" class="input-background"
                          ></a-rounded-box>
                          <a-entity position="1.2 -0.45 0.02" rotation="0 0 0" scale="4 4 4"
                                    html="html:#device-${dIndex}-name-input; cursor:#cursor" data-raycastable>
                          </a-entity>
                          <input  id="device-${dIndex}-name-input" type="text" class="device-input device-nickname"
                                 value="${nickname}" style="color: ${isDarkTheme ? "#fff" : "#111"}">
                      </a-entity>
                      <a-entity
                              ui-button="label: Save; type:rounded-box; width: 1.4; height: 0.4; depth: 0.01; colorScheme: accent;
                      radius: 0.09; preferredFontSize: 0.15"
                              position="1.3 -0.6 0.01" class="btn-save-nick"
                      ></a-entity>
                      <!-- Line 3 -->
                      <a-text value="Device ID:" color="#aaa"
                              align="left" anchor="left" baseline="top"
                              position="-2 -1 0" scale="0.6 0.6 0.6"></a-text>
                      <a-text value="${deviceIdShort}" color=${isDarkTheme ? "#fff" : "#111"} 
                              align="left" anchor="left" baseline="top"
                              position="-1.3 -1 0" scale="0.6 0.6 0.6"></a-text>

                      <a-text value="Last used:" color="#aaa"
                              align="left" anchor="left" baseline="top"
                              position="-2 -1.2 0" scale="0.6 0.6 0.6"></a-text>
                      <a-text value="${lastUsed}" color=${isDarkTheme ? "#fff" : "#111"} 
                              align="left" anchor="left" baseline="top"
                              position="-1.3 -1.2 0" scale="0.6 0.6 0.6"></a-text>

                      <a-entity
                        ui-button="label: Remove Device; type:rounded-box; width: 1.4; height: 0.4; depth: 0.01; colorScheme: destructive; 
                      radius: 0.09; preferredFontSize: 0.15"
                              position="1.3 -1.1 0.01" class="btn-unlink"
                      ></a-entity>

                      <!-- Divider Line -->
                      <a-rounded-box width="4" height="0.02" depth="0.01" color=${isDarkTheme ? "#202028" : "#ddd"} class="divider-line" visible="true"
                                     radius="0" position="0 -1.5 0.01" scale="1 1 1" opacity="1" material="shader: flat; color: #202028"
                      ></a-rounded-box>
        `;
        els.devicesList.appendChild(item);

        dIndex++
        dPositionY -= 1.7;
    }

    if (els.devicesMsg) els.devicesMsg.textContent = `${fullDevicesList.length} device(s)`;

    // adjust size popup
    const popupBg = els.linkedDevicesModal.querySelector('.popup-bg');
    if (popupBg) {
      popupBg.setAttribute('height', 10.650);
    }

    const btnSignoutAll = document.getElementById('btn-signout-all-devices');
    if (btnSignoutAll) {
      const baseOffset = totalPages > 1 ? 1.2 : 0.4;
      const posY = - (DEVICES_PER_PAGE - 1) * 1.7 - baseOffset;
      btnSignoutAll.setAttribute('position', `-1 ${posY} 0.05`);
    }

    renderPaginationControls(totalPages);
  }

  function renderPaginationControls(totalPages) {
    let container = document.getElementById('devices-pagination-container');
    if (container) container.remove();

    if (totalPages <= 1) return;

    container = document.createElement('a-entity');
    container.setAttribute('id', 'devices-pagination-container');

    const posY = - (DEVICES_PER_PAGE - 1) * 1.7 - 2.1;
    container.setAttribute('position', `0 ${posY} 0.02`);
    els.devicesList.appendChild(container);

    const isDark = getCurrentTheme() === 'Dark';
    const textColor = isDark ? '#ffffff' : '#000000';
    const btnGap = 0.8;

    if (currentPage > 0) {
        const prevBtn = document.createElement('a-entity');
        prevBtn.setAttribute('position', `${-btnGap} 0 0`);
        prevBtn.setAttribute('ui-button', {
            label: '<',
            width: 0.4,
            height: 0.4,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.05,
            depth: 0.02,
            preferredFontSize: 0.15
        });
        prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            currentPage--;
            renderDevices();
        });
        container.appendChild(prevBtn);
    }

    const pageText = document.createElement('a-troika-text');
    pageText.setAttribute('value', `${currentPage + 1} / ${totalPages}`);
    pageText.setAttribute('align', 'center');
    pageText.setAttribute('color', textColor);
    pageText.setAttribute('font-size', '0.15');
    pageText.setAttribute('anchor', 'center');
    pageText.setAttribute('position', '0 0 0');
    container.appendChild(pageText);

    if (currentPage < totalPages - 1) {
        const nextBtn = document.createElement('a-entity');
        nextBtn.setAttribute('position', `${btnGap} 0 0`);
        nextBtn.setAttribute('ui-button', {
            label: '>',
            width: 0.4,
            height: 0.4,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.05,
            depth: 0.02,
            preferredFontSize: 0.15
        });
        nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            currentPage++;
            renderDevices();
        });
        container.appendChild(nextBtn);
    }
  }

  function formatDate(dateString) {
    const date = new Date(dateString);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  }

  async function saveNickname(deviceId, value){
    const token = await getBearer();
    if (!token) return;
    try {
      await apiRequest('PATCH', `/devices/${encodeURIComponent(deviceId)}`, { nickname: value }, { bearer: token });
      await refreshDevices();
    } catch (_) {}
  }

  async function unlinkDevice(deviceId){
    const token = await getBearer();
    if (!token) return;
    try {
      await apiRequest('DELETE', `/devices/${encodeURIComponent(deviceId)}`, null, { bearer: token });

      // If unlinking current device, clear local bound flag
      try {
        const sessionStr = localStorage.getItem('auth_session');
        if (sessionStr) {
          const session = JSON.parse(sessionStr);
          const currentDeviceId = session?.value?.device_id || session?.device_id;
          if (currentDeviceId && String(currentDeviceId) === String(deviceId)) {
            localStorage.removeItem('ss_device_bound');
            const protectedKeys = JSON.parse(localStorage.getItem('protectedKeys') || '[]');
            const idx = protectedKeys.indexOf('ss_device_bound');
            if (idx > -1) {
              protectedKeys.splice(idx, 1);
              localStorage.setItem('protectedKeys', JSON.stringify(protectedKeys));
            }
          }
        }
      } catch(_) {}

      await refreshDevices();
    } catch (_) {}
  }

  function onTableClick(ev){
    const t = ev.target;
    if (t.classList.contains('btn-unlink')){
      const deviceId = t.closest('.device-item').getAttribute('data-device-id');
      const deviceName = t.closest('.device-item').getAttribute('data-device-name')
      showConfirmRemoveDeviceModal(deviceId, deviceName)
    } else if (t.classList.contains('btn-save-nick')){
      const deviceId = t.closest('.device-item').getAttribute('data-device-id');
      const input = t.closest('.device-item').querySelector('.device-nickname');
      saveNickname(deviceId, input ? input.value : '');
    }
  }

  async function onSignoutAllDevices(){
    if(window.gtag) gtag('event', `VR_AccountManagement_LogOutAllDevices`);


    try {
      dl('signoutAll.click');
      const token = await getBearer();
      if (!token) { dl('signoutAll.noBearer'); alert('Sign in required'); return; }

      const API = getAuthAPI();
      if (API && typeof API.signOut === 'function') {
        await API.signOut({ global: true });
        dl('signoutAll.ok');
        if (els.devicesMsg) els.devicesMsg.textContent = 'Signed out of all devices';
        if (window.AuthUI.showMessage && typeof window.AuthUI.showMessage === 'function') {
          window.AuthUI.showMessage('You have logged out of all devices.');
        }
        hideLinkedDevicesModal();
      } else {
        // Fallback to manual server call if AuthAPI is missing
        await apiRequest('POST', '/auth/signout-all', null, { bearer: token });
        await apiRequest('POST', '/auth/signout');
        dl('signoutAll.ok');
        if (els.devicesMsg) els.devicesMsg.textContent = 'Signed out of all devices';
        if (window.AuthUI.showMessage && typeof window.AuthUI.showMessage === 'function') {
          window.AuthUI.showMessage('You have logged out of all devices.');
        }
        hideLinkedDevicesModal();
      }
    } catch (e) {
      dl('signoutAll.error', { status: e?.status, data: e?.data });
      if (els.devicesMsg) els.devicesMsg.textContent = 'Failed to sign out of all devices';
    }
  }

  async function onCleanupLinkCodes(){
    try {
      dl('cleanup.click');
      const token = await getBearer();
      if (!token) { dl('cleanup.noBearer'); alert('Sign in required'); return; }
      await apiRequest('POST', '/device-link/cleanup-me', null, { bearer: token });
      dl('cleanup.ok');
      if (els.devicesMsg) els.devicesMsg.textContent = 'Expired link codes cleaned';
    } catch (e) {
      dl('cleanup.error', { status: e?.status, data: e?.data });
      if (els.devicesMsg) els.devicesMsg.textContent = 'Cleanup failed';
    }
  }
  // Lazy module interface
  let __initialized = false;
  function bindAll(){
    if (__initialized) return; __initialized = true;
    if (els.btnRequest) els.btnRequest.addEventListener('click', onBtnRequest);
    // if (els.btnRegenerate) els.btnRegenerate.addEventListener('click', onBtnRequest);
    // if (els.claimForm) els.claimForm.addEventListener('submit', claimCode);
    if (els.btnRefreshDevices) els.btnRefreshDevices.addEventListener('click', refreshDevices);
    if (els.devicesList) els.devicesList.addEventListener('click', onTableClick);
    const btnSignoutAll = document.getElementById('btn-signout-all-devices');
    if (btnSignoutAll) btnSignoutAll.addEventListener('click', onSignoutAllDevices);
    const btnCleanup = document.getElementById('btn-cleanup-linkcodes');
    if (btnCleanup) btnCleanup.addEventListener('click', onCleanupLinkCodes);
    
    // custom
    //
    // auth button
    const authBtn = document.querySelector('#login-button .auth-button');
    if (authBtn) authBtn.addEventListener('click', onBtnRequest);
    
    // account management
    if (els.accountManagementBtn) els.accountManagementBtn.addEventListener('click', showAccountManagementModal);
    if (els.accountManagementModal) {
      const accountManagementModalBg = els.accountManagementModal.querySelector('.bg');
      if (accountManagementModalBg) accountManagementModalBg.addEventListener('click', hideAccountManagementModal);
      const accountManagementModalCloseButton = els.accountManagementModal.querySelector('.close-button');
      if (accountManagementModalCloseButton) accountManagementModalCloseButton.addEventListener('click', hideAccountManagementModal);
      const stepBackButtons = els.accountManagementModal.querySelector('.back-button');
      if (stepBackButtons) stepBackButtons.addEventListener('click', () => {
        showAccountModal()
      });
    }
    
    // linked devices 
    if (els.linkedDevicesBtn) els.linkedDevicesBtn.addEventListener('click', showLinkedDevicesModal);
    if (els.linkedDevicesModal) {
        const linkedDevicesModalBg = els.linkedDevicesModal.querySelector('.bg');
        if (linkedDevicesModalBg) linkedDevicesModalBg.addEventListener('click', hideLinkedDevicesModal);
        const linkedDevicesModalCloseButton = els.linkedDevicesModal.querySelector('.close-button');
        if (linkedDevicesModalCloseButton) linkedDevicesModalCloseButton.addEventListener('click', hideLinkedDevicesModal);
        const stepBackButtons = els.linkedDevicesModal.querySelector('.back-button');
        if (stepBackButtons) stepBackButtons.addEventListener('click', () => {
          showAccountManagementModal()
        });
    }
    
    // pretty input 
    // if (els.claimCode) prettyInputPasscode(els.claimCode);

    // remove device
    if (els.removeDeviceModal) {
      const confirmRemoveDeviceBtn = els.removeDeviceModal.querySelector('.confirm-remove-device');
      const cancelRemoveDeviceBtn = els.removeDeviceModal.querySelector('.cancel-pop-up');
      if (confirmRemoveDeviceBtn) confirmRemoveDeviceBtn.addEventListener('click', handleRemoveDevice);
      if (cancelRemoveDeviceBtn) cancelRemoveDeviceBtn.addEventListener('click', hideConfirmRemoveDeviceModal);
    }
    
    if (els.linkButton) els.linkButton.addEventListener('click', claimCode);

  }
  function unbindAll(){
    if (!__initialized) return; __initialized = false;
    if (els.btnRequest) els.btnRequest.removeEventListener('click', onBtnRequest);
    if (els.claimForm) els.claimForm.removeEventListener('submit', claimCode);
    if (els.btnRefreshDevices) els.btnRefreshDevices.removeEventListener('click', refreshDevices);
    if (els.devicesList) els.devicesList.removeEventListener('click', onTableClick);

    const authBtn = document.querySelector('#main-header .auth-button');
    if (authBtn) authBtn.addEventListener('click', onBtnRequest);
  }
  function onBtnRequest(){
    if (els.btnRequest) {
      els.btnRequest.setAttribute('position', '0 10.82 0.03')
      els.btnRequest.setAttribute('visible', 'false')
    }
    dl('btn.requestCode.click'); requestCodeWithHeader().then(j=>dl('requestCode.success',{ link_id:j?.link_id, code: j?.code })).catch((e)=>{ dl('requestCode.error',{ status:e?.status, data:e?.data }); setDeviceStatus('request failed','text-bg-danger'); }); 
  }
  

  function cleanup(){
    console.log('cleanup')
    stopTtl();
    stopStatusPoll();
    try { if (ws) { ws.close(); } } catch(_){}
    ws = null; wsReady = false; ttlExpiresAt = null; currentLinkId = null;
  }

  window.DeviceLinkUI = window.DeviceLinkUI || {};
  let __currentPrefix = '';
  window.DeviceLinkUI.init = function(prefix){
    __currentPrefix = prefix || '';
    selectEls(__currentPrefix);
    // Suppress /api/auth/session poll while linking UI is active
    try { window.__DL_SUSPEND_SESSION_POLL = true; dl('poll.suspend.on'); } catch(_) {}
    bindAll();
    setupAuthWatch();
    connectWS();


    const sceneEl = document.querySelector('a-scene');
    if (sceneEl.hasLoaded) {
      registerPopups();
    } else {
      sceneEl.addEventListener('loaded', registerPopups);
    }
    
    // Only try to load devices table if present in this context
    // if (els.devicesList) refreshDevices();
  };
  window.DeviceLinkUI.destroy = function(){
    unbindAll();
    teardownAuthWatch();
    cleanup();
    try { window.__DL_SUSPEND_SESSION_POLL = false; dl('poll.suspend.off'); } catch(_) {}
    __currentPrefix = '';
    selectEls('');
  };

  // Auto-bind to modal lifecycle without auto-initializing sockets until shown
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupModalHooks);
    } else {
      setupModalHooks();
    }
  }

  function setupModalHooks(){
    window.DeviceLinkUI.init('');
  }
  
  // custom functions  
  function handleRemoveDevice() {
    const deviceId = els.removeDeviceModal.dataset.deviceId;
    if (!deviceId) return;
    unlinkDevice(deviceId).then(() => {
      hideConfirmRemoveDeviceModal();
    }).catch((e) => {
      console.error('Failed to unlink device', e);
      hideConfirmRemoveDeviceModal();
    });
   
  }

  function registerPopups() {
    if (!window.PopupManager) return;

    window.PopupManager.register('account-management-pop-up', els.accountManagementModal);
    window.PopupManager.register('linked-devices-pop-up', els.linkedDevicesModal);
  }
  
  
  //
  // show/hide modals
  //
  function showAccountModal() {
    if (window.PopupManager) window.PopupManager.open('account-pop-up');
  }
  
  function showAccountManagementModal() {
    if (window.PopupManager) window.PopupManager.open('account-management-pop-up');

    if(window.gtag) gtag('event', `VR_AccountManagement`);
  }
  function hideAccountManagementModal() {
    if (window.PopupManager) window.PopupManager.close('account-management-pop-up');
  }
  
  function hideAuthPopUp() {
    if (window.PopupManager) window.PopupManager.close('authorization-pop-up');
  }
  
  function showLinkedDevicesModal() {
    refreshDevices(true);
    if (window.PopupManager) window.PopupManager.open('linked-devices-pop-up');
    const popupBg = els.linkedDevicesModal.querySelector('.popup-bg');
    if (popupBg) {
        popupBg.setAttribute('data-raycastable', 'true');
    }

    if(window.gtag) gtag('event', `VR_AccountManagement_ManageLinkedDevices`);
  }
  function hideLinkedDevicesModal() {
    if (window.PopupManager) window.PopupManager.close('linked-devices-pop-up');
    const popupBg = els.linkedDevicesModal.querySelector('.popup-bg');
    if (popupBg) {
      popupBg.removeAttribute('data-raycastable');
    }
  }
  
  function showConfirmRemoveDeviceModal(deviceId, deviceName) {
    if (els.removeDeviceModal) {
      els.removeDeviceModal.setAttribute('visible', 'true')
      els.removeDeviceModal.setAttribute('scale', '0.2 0.2 0.2')
      
      els.removeDeviceModal.dataset.deviceId = deviceId
      // const deviceNameEl = els.removeDeviceModal.querySelector('.device-name')
      // if (deviceNameEl) deviceNameEl.textContent = deviceName;
    }
  }
  function hideConfirmRemoveDeviceModal() {
    if (els.removeDeviceModal) {
      els.removeDeviceModal.setAttribute('visible', 'false')
      els.removeDeviceModal.setAttribute('scale', '0 0 0')
      // const deviceNameEl = els.removeDeviceModal.querySelector('.device-name')
      // if (deviceNameEl) deviceNameEl.textContent = '';
    }
  }
  
  //
  // utils
  //

  function detectBrowser() {
    if (navigator.userAgentData && navigator.userAgentData.brands) {
      const brands = navigator.userAgentData.brands.map(b => b.brand.toLowerCase());

      if (brands.some(b => b.includes('chrome'))) return 'Chrome';
      if (brands.some(b => b.includes('edge'))) return 'Edge';
      if (brands.some(b => b.includes('opera'))) return 'Opera';
    }
    
    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes("edg")) return "Edge";
    if (ua.includes("opr") || ua.includes("opera")) return "Opera";
    if (ua.includes("chrome") && !ua.includes("edg")) return "Chrome";
    if (ua.includes("safari") && !ua.includes("chrome")) return "Safari";
    if (ua.includes("firefox")) return "Firefox";
    if (ua.includes("msie") || ua.includes("trident")) return "Internet Explorer";

    return "Unknown browser";
  }
  
  function showMessageWithVerificationAuthUI(text) {
    if (window.AuthUI.showMessage && typeof window.AuthUI.showMessage === 'function') {
      window.AuthUI.showMessage(text);
    }
  }
  
  function getCurrentTheme() {
    let themeMode = 'Dark'
    const mainSettings = getCacheItem('mainSettings');
    if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
      themeMode = mainSettings.themeMode;
    } else {
      const parsed = getCacheItem('configureControlSettings');
      if (parsed && (parsed.themeMode === 'Light' || parsed.themeMode === 'Dark')) {
        themeMode = parsed.themeMode;
      }
    }
    
    return themeMode
  }
})();
